import React, { useState, useEffect } from 'react'
import InlineSVG from 'svg-inline-react'

import styled from '@emotion/styled'
import { useDispatch, useSelector } from 'react-redux'
import * as Actions from 'state/actions'
import { getTriggerEvents, getSelectedState } from 'state/selectors'

import iconSearch from 'assets/icons/ico-search.svg'

const TriggerEventsContainer = styled.main`
  display: flex;
  flex-direction: column;
  height: 176px;
  width: 240px;
  padding: 8px;
  box-shadow: 0 0 16px rgba(53, 58, 82, 0.16);
`

const InputContainer = styled.div`
  display: flex;
  width: 100%;
  height: 32px;
  border-radius: 4px;
  background-color: #EEF1F2;
  line-height: 18rem;
`

const Input = styled.input`
  width: 100%;
  height: 32px;
  background-color: #EEF1F2;
  padding-right: 6px;
  border: none;
  color: black;
  font-size: 13rem;
`

const EventNamesList = styled.div`
  margin-top: 8px;
  padding-right: 8px;
  overflow-y: scroll;
  height: 100%;
`

const EventName = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 30px;
  padding-left: 8px;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background-color: #EEF1F2;
  }
`

const NoEventsTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #90A1B0;
  font-size: 20px;
`

const Icon = styled(InlineSVG)`
  display: flex;
  align-items: center;
  width: 14px;
  cursor: pointer;
  margin: 5px 10px 5px 10px;
`

const TriggerEventPicker = () => {
  const dispatch = useDispatch()
  const triggerEvents = useSelector(getTriggerEvents)
  const isEventTriggerRequesting = useSelector(getSelectedState).isEventTriggerRequesting

  const [searchEvent, setSearchEvent] = useState('')
  const [searchResults, setSearchResults] = useState([])

  const handleChange = e => {
    setSearchEvent(e.target.value)
  }

  useEffect(() => {
    const results = triggerEvents
      .sort()
      .filter(event =>
        event.toLowerCase().includes(searchEvent.toLowerCase())
      )
    setSearchResults(results)
  }, [searchEvent, triggerEvents])

  const handleEventTrigger = (eventName) => {
    if (!isEventTriggerRequesting) dispatch(Actions.triggerEvent(eventName))
  }
  return (
    <TriggerEventsContainer>
      <InputContainer>
        <Icon src={iconSearch} />
        <Input
          placeholder="Search..."
          onChange={handleChange}
        />
      </InputContainer>
      <EventNamesList>
        {!searchResults.length && (
          <NoEventsTitle>
            No events
          </NoEventsTitle>
        )}
        {searchResults.map((eventName, key) => {
          return (
            <EventName
              key={key}
              onClick={() => {
                handleEventTrigger(eventName)
                document.body.click() // to close Popover after click
              }}
            >
              {eventName}
            </EventName>
          )
        })}
      </EventNamesList>
    </TriggerEventsContainer>
  )
}

TriggerEventPicker.propTypes = {}

export default TriggerEventPicker